'use client'
import { datadogRum } from '@datadog/browser-rum'
let env = 'dev'
let sessionSampleRate = 100

if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    if (hostname === 'giphy.com' || /media[0-4]?\.giphy\.com/.test(hostname)) {
        env = 'prod'
    } else if (hostname === 'beta.giphy.com') {
        env = 'beta'
    } else if (hostname === 'dev.giphy.tech' || hostname === 'local.giphy.com') {
        env = 'dev'
    }
}

let initRUM = true
if (typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent?.toLowerCase() ?? ''

    if (
        userAgent.includes('bot') ||
        userAgent.includes('spider') ||
        userAgent.includes('crawl') ||
        userAgent.includes('naver') ||
        userAgent.includes('yeti')
    ) {
        // Do not initialize DataDog RUM for bots
        initRUM = false
    }
}

if (typeof window !== 'undefined' && initRUM && window.location.pathname.startsWith('/edit/gifs')) {
    datadogRum.init({
        applicationId: 'f93f69ab-bd3a-48c9-bab0-2d17c49fbc65',
        clientToken: 'pub79c43b4ac8dd92ae4d6819c7f6e46c44',
        site: 'datadoghq.com',
        service: 'curation-station',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        env,
        // version: ddVersion,
        sessionSampleRate,
        sessionReplaySampleRate: 1,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        // traceSampleRate is for backend traces (APM) that are
        // tied to RUM sessions. This is not for browser traces.
        // This can cause a large ingest rate for APM.
        // https://docs.datadoghq.com/real_user_monitoring/platform/connect_rum_and_traces/?tab=browserrum
        traceSampleRate: 1,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: function (event) {
            if (event.type === 'view') {
                const url = new URL(event.view.url)
                if (url.pathname.startsWith('/edit/gifs')) {
                    event.view.name = '/edit/gifs'
                    event.view.full_url = event.view.url
                }
            }
            return true
        },
    })
}

export function DatadogProvider() {
    // Render nothing - this component is only included so that the init code
    // above will run client-side
    return null
}
